module.exports = __webpack_public_path__ + "img/getongplay.9c5ab0d2.png";